import Axios from 'axios'
import qs from 'qs'
import { toggleDefaultData } from './toggle'

const batch = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },
  axiosV3() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.TRACEABILITY_BASE_URL
    return AxiosInstance
  },
  getBatches(
    offset,
    limit,
    startDate,
    endDate,
    patientName,
    packagingType,
    batchLabel,
    codeOriginLis,
    codeOriginAlvaro,
    collectionPointName,
    source
  ) {
    return this.axios().get('/batch/batches-list', {
      params: {
        limit,
        offset: offset * limit,
        startDate,
        endDate,
        patientName,
        packagingType,
        batchLabel,
        codeOriginLis,
        codeOriginAlvaro,
        collectionPointName,
        asyncBatch: toggleDefaultData()?.feature.nonSegregatedBatchList,
        source,
      },
      paramsSerializer(params) {
        return qs.stringify(params, {
          indices: false,
        })
      },
    })
  },
  getBatchesByCollectionPoint(collectionPointName) {
    return this.axios().get('/batch/batches-list', {
      params: {
        limit: 1000,
        collectionPointName,
        asyncBatch: toggleDefaultData()?.feature.nonSegregatedBatchList,
      },
      paramsSerializer(params) {
        return qs.stringify(params, {
          indices: false,
        })
      },
    })
  },
  getBatchesGrouped(
    limit,
    offset,
    startDate,
    endDate,
    patientName,
    packagingType,
    batchLabel,
    codeOriginLis,
    codeOriginAlvaro,
    collectionPointName
  ) {
    return this.axios().get('/batch/batches-list/grouped-by-source', {
      params: {
        limit,
        offset: offset * limit,
        startDate: startDate,
        endDate: endDate,
        patientName: patientName,
        packagingType: packagingType,
        batchLabel: batchLabel,
        codeOriginLis: codeOriginLis,
        codeOriginAlvaro: codeOriginAlvaro,
        collectionPointName: collectionPointName,
      },
      paramsSerializer(params) {
        return qs.stringify(params, {
          indices: false,
        })
      },
    })
  },
  printBatchTag(batchIds) {
    return this.axios().post('/batch/print', batchIds)
  },
  getBatchSamples({ batchId, docDelivered, filters }) {
    const toggleData = toggleDefaultData()

    return this.axios().get(`/batch/${batchId}/batch-samples`, {
      params: {
        docDelivered: docDelivered,
        ...filters,
        asyncBatch: toggleData?.feature.nonSegregatedBatchList,
      },
    })
  },
  transmitAndPrint(batch) {
    return this.axios().post('/batch/transmit-and-print', batch)
  },
  printBatchSamples(batch) {
    return this.axios().post('/batch/print-samples', batch)
  },
  getBatchDetails(param) {
    const toggleData = toggleDefaultData()
    const params = {
      asyncBatch: toggleData?.feature.nonSegregatedBatchList,
    }

    if (param.isWs) return this.axios().get(`batch/aolws/${param.id}`)
    return this.axios().get(`batch/${param.id}`, { params })
  },
  async insertSampleIntoWSBatch({ batchIdentifier, samples }) {
    return await this.axios().post('/batch/aolws/manual', {
      batchIdentifier,
      samples
    });
  },
  async insertSampleIntoBatch({ batchIdentifier, samples }) {
    return await this.axios().post('/batch/manual', {
      batchIdentifier,
      samples
    });
  },
  async createBatch({ samples }) {
    return await this.axios().post('/batch/manual', {
      samples
    });
  },
  async createWSBatch({ samples }) {
    return await this.axios().post('/batch/aolws/manual', {
      samples
    });
  },
  async removeSamplesFromBatch(barcode, batchId, isMoving = false) {
    const params = { isMoving }
    return await this.axios().delete(`/sample/${barcode}/batch/${batchId}`, { params })
  },
  async removeSamplesFromWSBatch(sampleBarcode, batchIdentifier) {
    return await this.axios().delete(`/sample/aolws/${sampleBarcode}/batch/${batchIdentifier}`)
  },
  async removeSamplesFromWSBatchToMove(barcode, batchId, newBatchId) {
    return await this.axios().delete(`/sample/aolws/${barcode}/${batchId}/${newBatchId}`)
  },
  autoBatchSamples(samples) {
    return this.axios().post('/batch/automatic', samples)
  },
  getBatchesCompatibleWithSamples(samples) {
    return this.axios().get('/batch/compatible-batches', {
      params: {
        barcodes: samples.join(',')
      },
    })
  },
  printBatchTag(batchIds) {
    return this.axios().post('/batch/print', batchIds)
  },
  getBatchSamples({ batchId, docDelivered }) {
    const toggleData = toggleDefaultData()

    return this.axios().get('/batch/' + batchId + '/batch-samples', {
      params: {
        docDelivered: docDelivered,
        asyncBatch: toggleData?.feature.nonSegregatedBatchList,
      },
    })
  },
  transmitAndPrint(batch) {
    return this.axios().post('/batch/transmit-and-print', batch)
  },
  printBatchSamples(batch) {
    return this.axios().post('/batch/print-samples', batch)
  },
  getBatchDetails(param) {
    const toggleData = toggleDefaultData()
    const params = {
      asyncBatch: toggleData?.feature.nonSegregatedBatchList,
    }

    if (param.isWs) return this.axios().get('batch/aolws/' + param.id)
    return this.axios().get('batch/' + param.id, { params })
  },
  getBatchStatus(filter) {
    return this.axiosV3().get('/lot/indicators', { params: filter })
  },
  getBatchByDestinationId(params) {
    return this.axiosV3().get('/ntoByLot', {
      params: {
        idDestination: params.destinationId,
        status: params.status,
        lotId: params.batchCode,
        startDate: params.startDate,
        endDate: params.endDate,
      },
    })
  },
  getBatchDetailsByLotId(lotId) {
    return this.axiosV3().get(`/lotDetails/${lotId}`)
  },
}

export default batch
